<template>
  <model-table
    title="Vouchers"
    :collection="membershipType.membershipVouchers"
    :submodel="true"
    :columns="[
      { field: 'name', align: 'left', sortable: true },
      { name: 'voucher', align: 'left', field: row => row.voucherType.name, sortable: true },
      { name: 'limit', align: 'left', field: row => { return row.limitRedemptions ? $_.startCase(row.redemptionsLimit + ' every ' + row.renews + ' ' + row.renewalTerm) : 'Unlimited' } },
      { field: 'formattedConditions', align: 'left', label: 'Conditions', component: 'chips', limitValues: 3 },
      { name: 'enable', align: 'left', label: 'Enabled', field: 'enable', component: 'checkmark-or-negative' },
      { field: 'actions', label: 'Actions' }
    ]"
    add-label="Voucher"
  >
    <membership-voucher-form
      ref="membershipVoucherForm"
      :submodel="true"
      :membership-type="membershipType"
    />
  </model-table>
</template>

<script>

import MembershipType from 'src/models/membership-type/MembershipType'
import ModelTable from 'src/modules/admin/components/ModelTable'
import MembershipVoucherForm from 'src/modules/admin/membership-type/MembershipVoucherForm'

export default {
  name: 'MembershipVoucherTable',
  components: {
    ModelTable,
    MembershipVoucherForm
  },
  props: {
    membershipType: {
      type: MembershipType,
      required: true
    }
  }
}
</script>
